/** Permanent URL of the latest Windows installer (monorepo infra/modules/installer-bucket). */
export const POS_WINDOWS_DOWNLOAD_URL = 'https://download.samly.uz/pos/windows'

/** The back office links here to open the install guide. */
export const INSTALL_GUIDE_HASH = '#install-windows'

/** null = not published yet → disabled «Скоро» badge. */
export type StoreLinks = { appStore: string | null; googlePlay: string | null }

export const MOBILE_APPS: { owner: StoreLinks; waiter: StoreLinks } = {
  owner: { appStore: null, googlePlay: null },
  waiter: {
    appStore: 'https://apps.apple.com/app/samly-waiter/id6762346537',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.ebrain.samly_waiter',
  },
}
